import { EmailField, useTranslate } from "react-admin";
import React, { Fragment } from "react";

import { Typography } from "@material-ui/core";
import { get } from "lodash";
import moment from "moment";

const UserField = ({
  source,
  record,
  basePath,
  sortBy,
  sortable,
  ...props
}) => {
  const translate = useTranslate();

  const value = get(record, source, translate("ra.defaults.unknown"));
  const lastLogin = get(record, "user.last_login", null);
  let caption = translate("ra.user.never_logged_in");
  if (lastLogin !== null) {
    caption = translate("ra.user.last_login", {
      lastLogin: moment(lastLogin).format(translate("app.date_format.long")),
    });
  }

  return (
    <Fragment>
      <Typography {...props}>{value}</Typography>
      <Typography
        variant="body2"
        color={lastLogin === null ? "textSecondary" : "textPrimary"}
      >
        {caption}
      </Typography>
      <EmailField source="email" record={get(record, "user")} />
    </Fragment>
  );
};
export default UserField;
